import {comparators, comparatorsField, makeArr, objToArrK, sortKeys} from "../tools/CommonJS";
import HA_types from "analyzer-types/AnalyzerTypes.json";
import {doesSearchIncTpc, severitiesDefs} from "./CommonUIData";
export const HA_topics = HA_types.topics;
export const HA_Remedies = HA_types.remediations;
export const HA_genRemedies = HA_types.genericRemediations;
export const HA_relatedTopics = HA_types.relatedTopics;

export const misconTopicOpts = Object.entries(HA_topics).map(([k, v]) => ({h: v.title, k}));

export function xHA_Repo(code) {
    if (!HA_topics) console.log(HA_types);
    return HA_topics[code] || {
        title: "Unrecognized: "+ code +". Please upgrade the software to the latest version.",
        severity: "Unknown",
        subj: "",
        desc: "",
        sgt: ""
    };
}

export function xHA_Remedies_Repo(action) {
    if (!HA_Remedies) console.log(HA_types);
    return HA_Remedies[action] || {
        title: "Unrecognized: " + action +". Please upgrade the software to the latest version",
        desc: "",
        topic: "",
        itMinutes: 4
    }
}
// export function HA_GetTopic(code) {
//     return AddKH_Host_Analyzer(xHA_Repo(code).title, code);
// }

export function HA_GetTopic_text(code) {
    return xHA_Repo(code).title;
}

export function getParamTitle(row) {
    const topic = HA_topics[row.topicCode];
    return topic?.paramTitle ?? "Alert";
}

// export function HA_cbSeverityLetter(code, sevIdx) {
//     const rep = xHA_Repo(code?.cellData ?? code);
//     return fmt.cbSeverityLetter(rep.severity, rep.star &&
//         <i className="ml-1 fa fa-star fa-lg text-cyan-500" title="Quick win: recommended to remediate immediately."/>, sevIdx);
// }

export function HA_GetRelOS(code) {
    return xHA_Repo(code).os || ["windows"];
}


export const misconTopicsFilterDefs = {
    all: {h: "All Attack Vectors", d: "All Attack Vectors.", filter: tpc => true},
    global: {h: "Trending Global", d: "Stay tuned with the world’s top global threats and make sure to keep them out of your organization.", filter: tpc => HA_topics[tpc.topicCode]?.global},
    star: {h: "Quick Wins", d: "Attack Vectors considered as Quick Win 'no brainer' remediations.", filter: tpc => HA_topics[tpc.topicCode]?.star},
    pinned: {h: "Pinned", d: "Attack Vectors that you've pinned.", filter: (tpc, pinned) => pinned.has(tpc.topicCode)},
    repeated: {h: "Reintroduced Alerts", d: "Attack Vectors with potential threats that reoccurred after a remediation.", filter: tpc => tpc.repeated},
    remediated: {h: "Remediated", d: "Attack Vectors which have been Remediated.", filter: tpc => tpc.remediated},
    // devices: {h: "Number of Devices", d: "All Attack Vectors sorted by highest number of devices affected.", filter: (tpc, pinned) => true},
    // alerts: {h: "Number of Alerts", d: "All Attack Vectors sorted by highest number of potential threats.", filter: (tpc, pinned) => true, kSort: "alertsBad"},
}, misconTopicsFilterDefsArr = objToArrK(misconTopicsFilterDefs);

export const misconTopicsSortDefs = {
    sevIdx: {h: "Severity", sort: comparators.number},
    cvss: {h: "CVSS", sort: comparators.numberSigRev},
    title: {h: "Attack Vector", sort: comparators.stringSig},
    devicesAll: {h: "Total Devices", sort: comparators.numberSigRev},
    devicesBad: {h: "Vulnerable Devices", sort: comparators.numberSigRev},
    alertsBad: {h: "Alerts", sort: comparators.numberSigRev},
    alertsNew: {h: "New Alerts", sort: comparators.numberSigRev},
    remediated: {h: "Remediated", sort: comparators.numberSigRev},
    repeated: {h: "Reintroduced Alerts", sort: comparators.numberSigRev},
}, misconTopicsSortDefsArr = objToArrK(misconTopicsSortDefs)


// read relatedTopics array (which has arrays of topicCodes), and create for each topic an array of related topics, of superset where this topic appears.
HA_relatedTopics.forEach(relTopics => relTopics.forEach(tp => HA_topics[tp] &&
    (HA_topics[tp].relatedTopics = (HA_topics[tp].relatedTopics || []).concat(relTopics).undup())));

export const actionTypes = {
    remediate: {h: "Remediate"},
    remediateAuto: {h: "Auto Remediate"},
    generic: {h: "Generic"},
    muteAlert: {h: "Mute Alert"},
    clientUpdate: {h: "Client Update"},
};


export const descByOs = (genDesc, osObj) => [
    genDesc,
    ...!osObj ? [] : Object.entries(osObj).map(([os, desc]) => desc && `${os}:\n${desc}`)
].filter(Boolean).join("\n\n");


export const miscFilterDefs = {
    Pinned: 'pinned',
    'Quick wins': 'star',
};

export const getTopicSeverityIdx = tpc =>
    severitiesDefs[tpc.severity || tpc.badge?.capitalizeFirst() || (tpc.alertsBad ? HA_topics[tpc.topicCode]?.severity : "Passed")]?.idx ?? 4;

export const c_allCat = "All";

export function filterMisconCategories({topics, category, severities, sortBy, sortDefs, search}) {
    let filtered, categoryOpts, severityVals = makeArr(4).map(i => ({k: i, v: 0}));

    if (topics) {
        topics.forEach(tpc => (severityVals[tpc.sevIdx] ?? {}).v++);
        filtered = topics.filter(tpc => !severities?.length || severities.includes(tpc.sevIdx));

        filtered.sort(comparatorsField((sortDefs[sortBy] ?? Object.values(sortDefs)[0]).sort, sortBy));

        const curCategories = sortKeys(filtered.groupBy(ent => xHA_Repo(ent.topicCode).subcategory));
        categoryOpts = [c_allCat, ...Object.keys(curCategories || {})].map(cat => ({
            h: cat, k: cat, n: curCategories[cat]?.length || filtered.length
        }));
        if (!curCategories[category]) category = c_allCat;

        if (category !== c_allCat) filtered = curCategories[category];
        if (search) filtered = filtered.filter(tpc => doesSearchIncTpc(HA_topics[tpc.topicCode], search));
    }
    return {filtered, categoryOpts, severityVals};
}